<div class="global-container spinner-container scr-page scr-page--wide scr-page--dense">
  @if (loading > 0) {
    <div class="spinner-overlay">
      <mat-spinner
        class="spinner-center indu-spinner"
        diameter="50"
        mode="indeterminate"
        >
      </mat-spinner>
    </div>
  }
  <!-- Dense working screen: no page header; the refresh time lives in the calendar toolbar. -->
  <h1 class="visually-hidden">Agenda de tareas</h1>

  <app-schedule-tasks-filter
    [visibility]="isVisible"
    (filterEvent)="filterSchedule($event)"
    (appliedFilter)="mostrarFiltro.description = $event"
  ></app-schedule-tasks-filter>

  <app-tag id="anchor" [visibility]="tagIsVisible"> </app-tag>

  @if (getFilterCount() || showFilters) {
  <div class="fil-container">
    @if (getFilterCount()) {
      <button class="apply-filters" type="button" (click)="toggleFilters()" [attr.aria-expanded]="showFilters">
        <mat-icon aria-hidden="true">filter_list</mat-icon>
        Filtros aplicados
        <span class="badge">{{ getFilterCount() }}</span>
        <mat-icon class="rotate-icon" [ngClass]="{ rotate: showFilters }" aria-hidden="true">chevron_right</mat-icon>
      </button>
    }
    @if (showFilters) {
      <ul class="filters-container">
        @for (group of mostrarFiltro.grouping; track group) {
          <li>
            <div class="filter-applied filter-div">
              <span>{{ group.groupName }}</span>
            </div>
            @if (group.jobs != null && group.jobs.length > 0) {
              <div
                class="filter-applied filter-div"
                >
                <span>{{
                  group.jobs.length > 3
                  ? group.jobs.length + " sub categorias"
                  : group.jobs
                }}</span>
              </div>
            }
          </li>
        }
        @if (mostrarFiltro.clientName.length != 0) {
          <li>
            @for (clientName of mostrarFiltro.clientName; track clientName) {
              <div
                class="filter-applied filter-div"
                >
                <span>{{ clientName }}</span>
              </div>
            }
          </li>
        }
        @if (mostrarFiltro.contractors.length != 0) {
          <li>
            @for (contractor of mostrarFiltro.contractors; track contractor) {
              <div
                class="filter-applied filter-div"
                >
                <span>{{ contractor }}</span>
              </div>
            }
          </li>
        }
        @if (mostrarFiltro.ignoredContractors.length != 0) {
          <li>
            @for (contractor of mostrarFiltro.ignoredContractors; track contractor) {
              <div class="filter-applied filter-div" title="Prestador ignorado">
                <span>Sin {{ contractor }}</span>
              </div>
            }
          </li>
        }
        @if (mostrarFiltro.creationDateFrom != null) {
          <li class="filter-applied">
            <span
              >{{ mostrarFiltro.creationDateFrom | date : "dd/MM/yyyy" }} al
              {{ mostrarFiltro.creationDateTo | date : "dd/MM/yyyy" }}</span
              >
            </li>
          }
          @if (mostrarFiltro.taskStatus.length != 0) {
            <li>
              @for (ts of mostrarFiltro.taskStatus; track ts) {
                <div
                  class="filter-applied filter-div"
                  >
                  <span>{{ ts }}</span>
                </div>
              }
            </li>
          }
          @if (mostrarFiltro.owner.length != 0) {
            <li>
              @for (ow of mostrarFiltro.owner; track ow) {
                <div
                  class="filter-applied filter-div"
                  >
                  <span>{{ ow }}</span>
                </div>
              }
            </li>
          }
          @if (mostrarFiltro.isPaidLabor != null) {
            <li class="filter-applied">
              <span>{{ mostrarFiltro.isPaidLabor }}</span>
            </li>
          }
          @if (mostrarFiltro.productName.length != 0) {
            <li>
              @for (product of mostrarFiltro.productName; track product) {
                <div
                  class="filter-applied filter-div"
                  >
                  <span>{{ product }}</span>
                </div>
              }
            </li>
          }
          @if (mostrarFiltro.sealesPointsNames.length != 0) {
            <li>
              @for (sealePoint of mostrarFiltro.sealesPointsNames; track sealePoint) {
                <div
                  class="filter-applied filter-div"
                  >
                  <span>{{ sealePoint }}</span>
                </div>
              }
            </li>
          }
          @if (mostrarFiltro.tags.length != 0) {
            <li>
              @for (ts of mostrarFiltro.tags; track ts) {
                <div
                  class="filter-applied filter-div"
                  >
                  <span>{{ ts }}</span>
                </div>
              }
            </li>
          }
        </ul>
      }
  </div>
  }

  <div class="schedule-layout" [class.schedule-layout--with-panel]="showNotScheduledTask">
    <div class="schedule-main">
      <div class="scr-card content-calendar" #scheduledContent>
        <ind-calendar
          [modalComponent]="modal"
          [lastUpdate]="lastUpdate"
          (closeOpenMonthViewDayEvent)="closeOpenMonthViewDay($event)"
          [showNotScheduledTask]="showNotScheduledTask"
          (showNotScheduledTaskEvent)="showNotScheduledTask = $event"
          (closeModalEvent)="closeModalEvent($event)"
          (closelistModalEvent)="closeModalEvent($event)"
          >
        </ind-calendar>
      </div>
    </div>
    @if (showNotScheduledTask) {
      <aside class="unscheduled-panel scr-card" aria-label="Tareas sin agendar">
        <div class="unscheduled-panel__header">
          <div>
            <h2 class="scr-section-title">Tareas sin agendar</h2>
            <p class="scr-hint">{{ totalCount }} {{ totalCount === 1 ? 'tarea' : 'tareas' }}</p>
          </div>
          <button type="button" class="hide-unscheduled-button" (click)="showNotScheduledTask = false">
            <mat-icon aria-hidden="true">chevron_right</mat-icon>
            Ocultar
          </button>
        </div>
        <div class="unscheduledContainer scrollable-content" #notScheduledContent>
          <div class="taskDetailContent">
            @for (task of notScheduledTask; track task) {
              <div
                class="cursor-pointer position-relative"
                >
                <div
                  class="row content-card"
                  (click)="!task.isReadOnly ? scheduleTask(task, 'view') : null"
                  >
                  <div class="col-12 detail pl-0 pr-0">
                    <mat-card
                      appearance="outlined"
              [ngClass]="{
                'read-only-card': task.isReadOnly,
                'pending-contact': applyPendingContactStyle(task)
              }"
                      >
                      <mat-card-title>
                        <div
                          class="row d-flex justify-content-start unscheduled-status-content"
                          >
                          <div
                            class="unscheduled-status"
                            [style.color]="getStatusSelectedColor(task.status)"
                    [style.background-color]="
                      getStatusColor(task.status).secondary
                    "
                            >
                            <span>{{ getStatusDescription(task.status) }}</span>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between">
                          <div class="d-flex justify-content-start">
                            {{ task.jobGroup }} - {{ task.taskType }}
                            @if (task.isPromotional) {
                              <div class="promo">
                                <img
                                  class="mb-1 ms-1"
                                  src="../assets/icons/promotional-icon/promotional-icon.png"
                                  alt=""
                                  />
                                </div>
                              }
                            </div>
                            <label class="third-party-app">{{
                              getThirdPartyAppName(task.fromThirdPartyApp)
                            }}</label>
                          </div>
                        </mat-card-title>
                        <mat-card-content>
                          @if (task.contractorName) {
                            <div>
                              <span>Prestador: {{ task.contractorName }}</span>
                            </div>
                          }
                          @if (task.contractorDni) {
                            <div>
                              <span>DNI: {{ task.contractorDni }} </span>
                            </div>
                          }
                          <div>
                            <span class="details"
                              >Detalle: {{ task.details }}
                            </span>
                          </div>
                          <div>
                            <span>Domicilio: {{ task.clientAddress }}</span>
                          </div>
                          <div>
                            <span>Creador: {{ task.ownerName }} </span>
                          </div>
                          <div class="row mt-1">
                            <ul class="task-tags">
                              @for (tag of task.tags; track tag) {
                                <li>
                                  <div
                                    class="tag-preview tag-list-item"
                                    [style.background-color]="tag.color"
                        [ngStyle]="{
                          '--after-background-color': tag.color
                        }"
                                    >
                                    <label class="tag-label">{{ tag.name }}</label>
                                  </div>
                                </li>
                              }
                            </ul>
                          </div>
                          @if (task.fromMobile) {
                            <mat-icon
                              title="Creado desde TuPiscinero App ©"
                              class="mobile-icon position-absolute"
                              >
                              stay_primary_portrait
                            </mat-icon>
                          }
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </div>
                </div>
              }
            </div>
          @if (!loading && notScheduledTask.length === 0) {
            <tp-empty-state
              icon="event_available"
              title="No hay tareas sin agendar"
              message="Todas las tareas tienen fecha asignada."
            ></tp-empty-state>
          }
        </div>
        <div class="paginator">
          <mat-paginator
            #paginator
            [length]="totalCount"
            [pageSize]="pageSize"
            [pageSizeOptions]="[30, 40, 50]"
            (page)="onPageChange($event)"
          ></mat-paginator>
        </div>
      </aside>
    }
  </div>
</div>
